import bannerImg from "@/assets/banner-featured-groups.png";

export default function FeaturedCommunitiesBanner() {
  return (
    <section className="px-5 sm:px-8 py-16 bg-slate-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-6">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-2">
            Your Group Gets Promoted to Thousands of New People
          </h2>
          <p className="text-gray-500 text-base max-w-2xl mx-auto">
            ClickSendAI features your community across our network of niche-targeted platforms — putting your group in front of the exact audience most likely to join and stay.
          </p>
        </div>
        <div className="rounded-2xl overflow-hidden shadow-2xl border border-amber-900/20">
          <img
            src={bannerImg}
            alt="ClickSendAI Featured Groups and Communities — Promoted Through the Growth Automation System"
            className="w-full h-auto object-cover"
          />
        </div>
      </div>
    </section>
  );
}
